var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"albums-container"},[_c('h2',[_vm._v("My Albums")]),(_vm.loading)?_c('div',[_vm._v("Loading...")]):_vm._e(),(_vm.loadingError)?_c('div',[_vm._v("There was an error: "+_vm._s(_vm.loadingError.message))]):_vm._e(),(_vm.albums)?_c('div',[_c('AlbumList',{attrs:{"albums":_vm.albums}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }